
import { React, useEffect } from 'react';
import AOS from 'aos';
import { Route, Routes } from 'react-router-dom';

import routes from './pages';
import Page404 from './pages/404';
import Header from './components/header/Header';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from './components/contextAPI/AuthContext';

function App() {
    const { user ,setUserObj } = useAuth()
    useEffect(() => {
        AOS.init({
            duration: 2000
        });
        setUserObj()
    }, []);

    return (
        <>

            <Header key={user} />

            <Routes>

                {
                    routes.map((data, idx) => (
                        <Route key={idx} path={data.path} element={data.component} exact />
                    ))
                }

                <Route path='*' element={<Page404 />} />
            </Routes>
            <ToastContainer />


        </>
    );
}

export default App;
